"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Uploadcare_1 = require("../Uploadcare");
var getImageExtension_1 = __importDefault(require("./lib/getImageExtension"));
var Image = function (props) {
    var extension = getImageExtension_1.default(props);
    // If it's a svg then there is no need for responsive image
    if (extension === 'svg') {
        return (react_1.default.createElement(Uploadcare_1.UploadcareSvg, __assign({}, props)));
    }
    // If it's a gif image then show it as a video, using Uploadcare's gif2video transformation
    if (extension === 'gif') {
        return (react_1.default.createElement(Uploadcare_1.UploadcareGif, __assign({}, props)));
    }
    // By default fallback to UploadcareImage with webp/png result formats
    return react_1.default.createElement(Uploadcare_1.UploadcareImage, __assign({ defaultFormat: "png", formats: ['webp', 'png'] }, props));
};
exports.default = Image;
//# sourceMappingURL=Image.js.map